import React, { useState, lazy } from 'react';
import { BookOpenIcon, CameraIcon, MessageSquareIcon, UsersIcon, HeartIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const BookContentSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const carouselImages = ['https://uploadthingy.s3.us-west-1.amazonaws.com/gDKeEuz73152P9iwCHhhAP/BAFD0EAD-68E2-4966-A634-ED6CE299EC4A-IMG_4572.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/akEJiE767apMqet8KuJbob/IMG_0551.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mNUQ9TGQ5gzKUt9AyS2pHG/12FE31B8-7FBB-4B6B-AF3E-6F8A6B519214-IMG_4573.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/j6A2J7PPvPEBeqoXotstvQ/IMG_0550.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9NsiPG9tCK3VB16n9bvtmG/88379DF7-81C8-473D-8AB7-2D664B104E05-IMG_4575.jpg'];
  const nextImage = () => {
    setCurrentImageIndex(prevIndex => prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1);
  };
  const prevImage = () => {
    setCurrentImageIndex(prevIndex => prevIndex === 0 ? carouselImages.length - 1 : prevIndex - 1);
  };
  const goToImage = (index: number) => {
    setCurrentImageIndex(index);
  };
  const features = [{
    icon: <BookOpenIcon className="h-8 w-8 text-bttf-accent shadow-neon-blue" data-id="element-38" />,
    title: 'The untold making-of stories',
    description: 'How late-night shoots, rewrites, and a recast turned chaos into magic.'
  }, {
    icon: <MessageSquareIcon className="h-8 w-8 text-bttf-accent shadow-neon-blue" data-id="element-39" />,
    title: '40 iconic quotes and their hidden meanings',
    description: 'Discover the stories behind the lines that defined a generation.'
  }, {
    icon: <UsersIcon className="h-8 w-8 text-bttf-accent shadow-neon-blue" data-id="element-40" />,
    title: 'Exclusive reflections from the cast and crew',
    description: 'How Back to the Future changed their lives forever.'
  }, {
    icon: <CameraIcon className="h-8 w-8 text-bttf-accent shadow-neon-blue" data-id="element-41" />,
    title: 'The cultural phenomenon that followed',
    description: 'Fan conventions, replicas, and the musical that brought Hill Valley back to life.'
  }, {
    icon: <HeartIcon className="h-8 w-8 text-bttf-accent shadow-neon-blue" data-id="element-42" />,
    title: 'The emotional heartbeat',
    description: 'How a friendship between Doc & Marty became a symbol of hope, humor, and humanity.'
  }];
  return <section className="py-6 md:py-8 bg-bttf-bg/90 relative" data-id="element-43">
      <div className="absolute inset-0 bg-gradient-to-r from-bttf-highlight/10 to-transparent opacity-30" data-id="element-44"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-45">
        <div className="text-center mb-6" data-id="element-46">
          <div className="flex justify-center mb-2" data-id="element-47">
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-48" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-main text-transparent bg-clip-text mb-2" data-id="element-49">
            Inside the Book You'll Discover…
          </h2>
          <div className="w-20 h-1 bg-bttf-primary mx-auto" data-id="element-50"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-51">
          {features.slice(0, 3).map((feature, index) => <div key={index} className="bg-bttf-bg/80 p-6 rounded-lg border border-bttf-accent/30 shadow-lg backdrop-blur-sm hover:shadow-neon-blue transition-shadow duration-300" data-id="element-52">
              <div className="flex justify-center mb-4" data-id="element-53">{feature.icon}</div>
              <h3 className="text-xl font-bold text-center mb-3 text-bttf-accent font-future" data-id="element-54">
                {feature.title}
              </h3>
              <p className="text-bttf-subtext text-center" data-id="element-55">
                {feature.description}
              </p>
            </div>)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mt-6" data-id="element-56">
          {features.slice(3, 5).map((feature, index) => <div key={index + 3} className="bg-bttf-bg/80 p-6 rounded-lg border border-bttf-accent/30 shadow-lg backdrop-blur-sm hover:shadow-neon-blue transition-shadow duration-300" data-id="element-57">
              <div className="flex justify-center mb-4" data-id="element-58">{feature.icon}</div>
              <h3 className="text-xl font-bold text-center mb-3 text-bttf-accent font-future" data-id="element-59">
                {feature.title}
              </h3>
              <p className="text-bttf-subtext text-center" data-id="element-60">
                {feature.description}
              </p>
            </div>)}
        </div>

        {/* Image Carousel */}
        <div className="max-w-2xl mx-auto mt-12 relative" data-id="element-61">
          <div className="relative overflow-hidden rounded-lg" data-id="element-62">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentImageIndex * 100}%)`
          }} data-id="element-63">
              {carouselImages.map((image, index) => <div key={index} className="w-full flex-shrink-0 px-4" data-id="element-64">
                  <div className="relative" data-id="element-65">
                    <div className="absolute -inset-1 bg-gradient-main rounded-lg blur-md opacity-50" data-id="element-66"></div>
                    <div className="relative w-full aspect-square rounded-lg shadow-2xl overflow-hidden" data-id="element-67">
                      <img src={image} alt={`Back to the Future Book Preview ${index + 1}`} className="w-full h-full object-cover rounded-lg" loading="lazy" data-id="element-68" />
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Navigation Buttons */}
          <button onClick={prevImage} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text p-3 rounded-full shadow-neon-orange transition-all duration-300 hover:scale-110 z-10" aria-label="Previous image" data-id="element-69">
            <ChevronLeftIcon className="h-6 w-6" data-id="element-70" />
          </button>
          <button onClick={nextImage} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text p-3 rounded-full shadow-neon-orange transition-all duration-300 hover:scale-110 z-10" aria-label="Next image" data-id="element-71">
            <ChevronRightIcon className="h-6 w-6" data-id="element-72" />
          </button>
          {/* Dots Navigation */}
          <div className="flex justify-center gap-3 mt-8" data-id="element-73">
            {carouselImages.map((_, index) => <button key={index} onClick={() => goToImage(index)} className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentImageIndex ? 'bg-bttf-primary shadow-neon-orange w-8' : 'bg-bttf-subtext/50 hover:bg-bttf-subtext'}`} aria-label={`Go to image ${index + 1}`} data-id="element-74" />)}
          </div>
        </div>
      </div>
    </section>;
};
const StarIcon = ({
  className
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-75">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-76"></polygon>
  </svg>;